import styled from 'styled-components';

import { StylesConfig } from 'react-select';

export const Container = styled.div`
  flex: 1;

  label {
    display: block;
    margin-bottom: 6px;
    color: #101d40;
    font-weight: 500;
    font-family: 'Sora', sans-serif;
  }
`;

export const reactSelectStyles: StylesConfig = {
  container: (styles) => ({
    ...styles,
  }),
  control: (styles, { isFocused }) => ({
    ...styles,
    fontFamily: '"Sora", sans-serif',
    fontSize: 13,
    height: '30px',
    padding: 10,
    alignContent: 'center',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    borderRadius: 5,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: isFocused ? '#329bfc' : '#e6effb',
    '&:hover': {
      borderColor: isFocused ? '#329bfc' : '#96cdff',
    },
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: 'none',
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: '#329bfc',
    padding: '0px 8px',
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    color: '#101d40',
    fontSize: 14,
    fontFamily: '"Sora", sans-serif',
    backgroundColor: isSelected ? 'rgba(242, 242, 242)' : 'transparent',
    fontWeight: isSelected ? 600 : 400,
    '&:hover': {
      backgroundColor: 'rgba(242, 242, 242)',
    },
  }),
};

export const ErrorMessage = styled.div`
  display: block;
  margin-top: 5px;
  font-weight: 500;
  color: #e12021;
  font-size: 14px;
  font-family: 'Sora', sans-serif;
`;
